<template>
  <div>
    <h2>Заказ #{{ id }}</h2>

    <div class="control">
      <button @click="saveItem()" class="btn btn-sm btn-info mr-2">
        <span class="ti-save"></span> Сохранить
      </button>
      <button @click="initSale()" class="btn btn-sm btn-warning">
        Расчитать скидку
      </button>
    </div>

    <ul class="body_content">
      <li v-for="(item, key) in purchases" :key="key">
        <div class="purchase_info">
          <div>
            <img :src="item.image" :alt="item.name" />
          </div>
          <div>
            <h5>{{ item.name }}</h5>
            <div>Ш.к: {{ item.sku }}</div>
            <div v-if="item.vendor">Артикул: {{ item.vendor.vendor }}</div>
            <div>Размер: {{ item.size }} ( {{ item.size_type }})</div>
            <h5 v-if="item.is_show">
              Цена товара: {{ (item.price*item.stock) | spaceBetweenNumber }} UZS
            </h5>
            <h5 v-if="item.is_show">
              Итог: {{ (setTotal(item)*item.stock) | spaceBetweenNumber }} UZS
            </h5>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-lg-6">
            <div>
              <checkbox @change="changeIsSale" v-model="item.is_sale" color="#ffc107"
                ><div class="mt-2">Carryover</div></checkbox
              >
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div>
              <checkbox v-model="item.is_show" color="#ffc107"
                ><div class="mt-2">Показать прайс</div></checkbox
              >
            </div>
          </div>

          <div v-if="item.is_show" class="col-12 col-md-8 col-lg-4">
            <fg-input
              type="numeric"
              :label="'Скидка по товару'"
              v-model="item.sale"
            ></fg-input>
          </div>
          <div v-if="item.is_show" class="col-12 col-md-8 col-lg-4">
            <fg-input
              type="numeric"
              :label="'Скидка по статусу'"
              v-model="item.sale_group"
            ></fg-input>
          </div>
          <div v-if="item.is_show" class="col-12 col-md-8 col-lg-4">
            <fg-input
              :disabled="item.is_sale === true"
              type="numeric"
              :label="'Доп скидка (акции)'"
              v-model="item.sale_add"
            ></fg-input>
          </div>

          <div v-if="item.is_show" class="col-12 col-md-8 col-lg-4">
            <fg-input
              type="numeric"
              :label="'Количество'"
              v-model="item.stock"
            ></fg-input>
          </div>

          <div class="col-12">
            <button @click="removeItem(item)" class="btn btn-sm btn-danger">
              <span class="ti-trash"></span>
            </button>
          </div>
        </div>
      </li>
    </ul>

    <div class="control">
      <button @click="saveItem()" class="btn btn-sm btn-info mr-2">
        <span class="ti-save"></span> Сохранить
      </button>
      <button @click="initSale()" class="btn btn-sm btn-warning">
        Расчитать скидку
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "groups",
  components: {},
  computed: {},
  props: ["id"],
  data() {
    return {
      purchases: [],
      itemLink: "admin/orders/card",
      cardLink: "admin/orders/card",
      sales: [40, 50, 75],
    };
  },
  created() {
    if (this.id) this.getPurchases();
  },
  methods: {
    saveItem() {
      this.$loading(true);
      this.$http
        .put(this.itemLink + "/purchases/update", {
          id: this.value,
          purchases: this.purchases,
          id: this.id,
        })
        .then((response) => {
          this.purchases = response.data;
          this.$notify({
            title: "Цены товаров",
            message: "Данные обновились",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch(() => {})
        .finally(() => {
          this.$loading(false);
          this.params.updatedAt = Date.now();
        });
    },
    setTotal(item) {
      let price = item.price - (item.price * item.sale) / 100;

      price = price - (price * item.sale_group) / 100;

      if (item.is_sale == 0) {
        price = price - (price * item.sale_add) / 100;
      }

      return Math.round(price);
    },

    removeItem(item) {
      for (let i = 0; i < this.purchases.length; i++) {
        if (item.id === this.purchases[i].id) {
          this.purchases.splice(i, 1);
          break;
        }
      }
    },
    changeIsSale() {
      for (let i = 0; i < this.purchases.length; i++) {
        if (this.purchases[i].is_sale===true) {
          this.purchases[i].sale_add = 0;
        }
      }
    },

    initSale() {
      let k = 0;

      for (let i = 0; i < this.purchases.length; i++) {
        if (
          this.purchases[i].is_show &&
          !this.purchases[i].is_sale
        ) {
          this.purchases[i].sale_add = this.sales[k];

          k++;

          if (k >= 3) {
            k = 0;
          }
        } else {
          this.purchases[i].sale_add = 0;
        }
      }
    },

    getPurchases() {
      this.$loading(true);
      this.$http
        .get(this.itemLink + "/purchases", {
          params: {
            id: this.id,
          },
        })
        .then((response) => {
          this.purchases = response.data;
        })
        .catch(() => {})
        .finally(() => {
          this.$loading(false);
        });
    },
    setPurchase(type) {
      this.$loading(true);
      if (this.id) {
        this.$http
          .put(this.itemLink + "/set", {
            id: this.value,
            type: type,
          })
          .then((response) => {
            this.$notify({
              title: "Цены товаров",
              message: "Данные обновились",
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          })
          .catch(() => {})
          .finally(() => {
            this.params.updatedAt = Date.now();
          });
      }
    },
  },
};
</script>
<style lang="scss">
ul.body_content {
  list-style: none;
  margin: 0;
  padding: 0;
  & > li {
    background: #f2f2f2;
    border-radius: 10px;
    margin-bottom: 20px;
    padding: 15px;
    & > .purchase_info {
      margin-bottom: 10px;
      display: flex;
      & > div {
        & > div {
          font-weight: bold;
          & > div:first-child {
            font-size: 18px;
          }
        }
        &:first-child {
          width: 90px;
        }
        &:last-child {
          width: calc(100% - 90px);
        }
        & img {
          height: 70px;
          width: 70px;
          object-fit: contain;
        }
      }
    }
  }
}
.control {
  margin: 20px 0;
}
</style>
